import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TicketContingentView.html?raw';
import { TicketTypes } from "../TicketTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import TicketApplicationForm from '../TicketApplicationForm/TicketApplicationForm';

class TicketContingentView extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private entity: TicketTypes.TicketContingentEntity;

    private sectionPassedEvent: HTMLElement;
    private sectionLockedEvent: HTMLElement;
    private sectionAppointmentInfo: HTMLElement;
    private btnNewRequest: HTMLElement;
    private dataContainer: HTMLElement;
    private txtTitle: HTMLElement;
    private txtContingentText: HTMLElement;
    private txtStatus: HTMLElement;
    private txtType: HTMLElement;
    private tableMyTickets: MdsLax<InstanceType<typeof StaticTable>>;
    private tableMyRequests: MdsLax<InstanceType<typeof StaticTable>>;
    private tableAllTickets: MdsLax<InstanceType<typeof StaticTable>>;

    //private listContainerMyTickets: HTMLElement;
    //private listContainerMyRequests: HTMLElement;
    //private expanderMyTickets: ExpandableSection;
    //private expanderMyRequests: ExpandableSection;
    private listContainerAllTickets: HTMLElement;
    private expanderAllTickets: MdsLax<InstanceType<typeof ExpandableSection>>;


    private tableFormatter(cell: StaticTable.StaticTableCell<TicketTypes.TicketEntity>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;


        switch (colName) {

            case "address3": // anbefragt von
                if (entity.ref_address_3?.ID == this.getCurrentEmployeeId()) {
                    value = this.createFontawesomeIcon("fas fa-user", "&nbsp;").outerHTML + value;
                }
                node.innerHTML = value;
                return true;
                break;
            case "address1": // angefragt für
                if (entity.ref_address_1?.ID == this.getCurrentEmployeeId()) {
                    value = this.createFontawesomeIcon("fas fa-user", "&nbsp;").outerHTML + value;
                }
                
                if (entity.c_address_2) {
                    value += "<br>" + entity.c_address_2;
                }
                node.innerHTML = value;
                return true;
                break;

            case "tickets_applied":
            case "tickets_approved":
                this.UiModder.domClass.add(node, "w3-medium");
                if (entity[colName] > 0) {
                    if (entity.tickets_applied == entity.tickets_approved) {
                        this.UiModder.domClass.add(node, "bold");
                    }
                } else {
                    this.UiModder.domClass.add(node, "w3-opacity");
                }
                break;

            default:
                node.innerHTML = value;
                break;
        }

        return false;
    }

   
    private _onClick_Ticket(row: StaticTable.StaticTableRow<TicketTypes.TicketEntity>) {
        this.openTicketForm(row.rowGroup.entity);
    }

    setEntity(entity: TicketTypes.TicketContingentEntity) {
        this.entity = entity;

        if (!entity) return;

        let now = new Date();
        this.disableNode(this.btnNewRequest,
            entity.ref_ev_planning.date_start.valueOf() < now.valueOf() || 
            entity.ref_pos_ev_calc_ticket_contingent_02_status.is_locking_type_A);

        this.hideNode(this.sectionPassedEvent, entity.ref_ev_planning.date_start.valueOf() > now.valueOf());
        this.hideNode(this.sectionLockedEvent, entity.ref_pos_ev_calc_ticket_contingent_02_status.is_locking_type_A != true);

        this.expanderAllTickets.setMarking(ExpandableSectionMarkings.hidden);
        //this.expanderMyTickets.setMarking(ExpandableSectionMarkings.hidden);
        //this.expanderMyRequests.setMarking(ExpandableSectionMarkings.hidden);

        //if (myRequests) {
        //    this.expanderMyRequests.toggleExpand(entity.myRequests.length > 0);
        //    this.expanderMyRequests.setMarking(entity.myRequests.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        //    this.tableMyRequests.setData(entity.myRequests);
        //}

        //if (myTickets) {
        //    this.expanderMyTickets.toggleExpand(entity.myTickets.length > 0);
        //    this.expanderMyTickets.setMarking(entity.myTickets.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        //    this.tableMyTickets.setData(entity.myTickets);
        //}

        if (entity.tickets) {
            this.expanderAllTickets.toggleExpand(entity.tickets.length > 0);
            this.expanderAllTickets.setMarking(entity.tickets.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            this.tableAllTickets.setData(entity.tickets);
        }

        if (entity.ticket_defaulttext) {
            this.hideNode(this.txtContingentText, false);
            this.txtContingentText.innerHTML = entity.ticket_defaulttext;
        }

        

        if (entity.ref_pos_ev_calc_ticket_contingent_02_status) {
            this.txtStatus.innerHTML = entity.ref_pos_ev_calc_ticket_contingent_02_status?.description;
            if (entity.ref_pos_ev_calc_ticket_contingent_02_status?.coloration) {
                this.UiModder.domStyle.set(this.txtStatus, "backgroundColor", entity.ref_pos_ev_calc_ticket_contingent_02_status.coloration.BackColor.Hex);
                this.UiModder.domStyle.set(this.txtStatus, "color", entity.ref_pos_ev_calc_ticket_contingent_02_status.coloration.TextColor.Hex);
            }

        } else {
            this.hideNode(this.txtStatus);
        }

        if (entity.ref_special_ticket_contingent_type) {
            this.txtType.innerHTML = entity.ref_special_ticket_contingent_type?.description;
            this.txtType.innerHTML += " (" + entity.tickets_applied + "/" + entity.tickets_plan + ")";

            if (entity.ref_special_ticket_contingent_type?.coloration) {
                this.UiModder.domStyle.set(this.txtType, "backgroundColor", entity.ref_special_ticket_contingent_type.coloration.BackColor.Hex);
                this.UiModder.domStyle.set(this.txtType, "color", entity.ref_special_ticket_contingent_type.coloration.TextColor.Hex);
            }
        } else {
            this.hideNode(this.txtType);
        }

        this.txtTitle.innerHTML = entity.ref_ev_planning.gDisp_1;

        this.disableNode(this.dataContainer, false);

        this.UiModder.domConstruct.empty(this.sectionAppointmentInfo);
        if (entity.appointmentHTML) {
            let expander = new ExpandableSection();
            expander.placeAt(this.sectionAppointmentInfo);
            expander.setup(entity.appointmentHTML,
                this.translate("WebCalendar__DetailView_label_bookingDetails"),
                "medium",
                true,
                true,
                false
            );

            this.hideNode(this.sectionAppointmentInfo, false);
        } else {
            this.hideNode(this.sectionAppointmentInfo);
        }

    }

    loadData(entityID?: string) {

        if (!entityID) entityID = this.entity.ID;

        if (!entityID) return;

        let data = {
            entityID: entityID
        };

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TicketPool__GetTicketContingentEntity",
            data,
            lang.hitch(this, this._onLoadContingentResponse),
            lang.hitch(this, this._onLoadContingentError)
        );
    }

    _onLoadContingentResponse(response: TicketTypes.TicketContingentEntity) {
        this.StandbyStop();
        this.setEntity(response);
    }

    _onLoadContingentError(err: more.requestErrorMessage) {
        alert(err.Message);
        this.disableNode(this.dataContainer);
        this.StandbyStop();
    }

  
   

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        const tableLineConfig: StaticTable.RowConfig = {
            attributes: ["c_address_1",
                "ref_address_3.gDisp_1",
                "ref_ev_calc_ticket_02_status.description",
                "tickets_applied",
                "tickets_approved"],
            colNamesInternal: ["address1",
                "address3",
                "status",
                null,
                null],
            headings: [
                this.translate("TicketPool_Label_" + "Address1"),
                this.translate("TicketPool_Label_" + "Address3"),
                this.translate("General_Label_" + "Status"),
                this.translate("TicketPool_Label_" + "TicketsApplied"),
                this.translate("TicketPool_Label_" + "TicketsApproved")
            ],
            bgColors: [null, null, "ref_ev_calc_ticket_02_status.coloration"],
            widths: [null, null, "15ch", "10ch", "10ch"]
        };

        //this.tableMyRequests = new StaticTable();
        //this.tableMyRequests.setTextOverflow(false);
        //this.tableMyRequests.placeAt(this.listContainerMyRequests);
        //this.tableMyRequests.setFormatter(lang.hitch(this, this.tableFormatter));
        //this.tableMyRequests.addLineConfig(tableLineConfig);
        //this.tableMyRequests.setRowClick(lang.hitch(this, this._onClick_Ticket));

        //this.tableMyTickets = new StaticTable();
        //this.tableMyTickets.setTextOverflow(false);
        //this.tableMyTickets.placeAt(this.listContainerMyTickets);
        //this.tableMyTickets.setFormatter(lang.hitch(this, this.tableFormatter));
        //this.tableMyTickets.addLineConfig(tableLineConfig);
        //this.tableMyTickets.setRowClick(lang.hitch(this, this._onClick_Ticket));

        
        this.tableAllTickets = new StaticTable();
        this.tableAllTickets.setContentOverflowClip(false);
        this.tableAllTickets.placeAt(this.listContainerAllTickets);
        this.tableAllTickets.setFormatter(lang.hitch(this, this.tableFormatter));
        this.tableAllTickets.addLineConfig(tableLineConfig);
        this.tableAllTickets.setRowClick(lang.hitch(this, this._onClick_Ticket));
        this.tableAllTickets.setCyAttribute("TicketContingentViewAllTicketsTable");


        //this.expanderMyRequests = new ExpandableSection();
        //this.expanderMyRequests.setup(
        //    this.listContainerMyRequests,
        //    this.translate("TicketPool_Label_MyRequests"),
        //    "small"
        //);

        //this.expanderMyTickets = new ExpandableSection();
        //this.expanderMyTickets.setup(
        //    this.listContainerMyTickets,
        //    this.translate("TicketPool_Label_MyTickets"),
        //    "small"
        //);

        this.expanderAllTickets = new ExpandableSection();
        this.expanderAllTickets.setup(
            this.listContainerAllTickets,
            this.translate("TicketPool_Label_AllContingentTickets"),
            "small"
        );

        this.expanderAllTickets.setMarking(ExpandableSectionMarkings.hidden);
        //this.expanderMyTickets.setMarking(ExpandableSectionMarkings.hidden);
        //this.expanderMyRequests.setMarking(ExpandableSectionMarkings.hidden);

    }

    private openTicketForm(entity?: TicketTypes.TicketEntity) {

        let form = new TicketApplicationForm();

        form.setContingent(this.entity);

        form.on("dirty", lang.hitch(this, this._onApplicationFormDirty));
        form.on("saved", lang.hitch(this, this._onTicketRequestSaved));

        //dlg.setUserdefinedButton(this.translations["TicketFinder_saveDataButton_label"], "fas fa-save", lang.hitch(form, form.saveTicket), false);      

        if (entity) {
            form.setTicket(entity);
        } else {
            form.startup();
        }

        form.openInDlg();       
    }

    private _onApplicationFormDirty(result: boolean) {
    }

    private _onClick_NewRequest(evt: MouseEvent) {
        this.openTicketForm(null);
    }

    private _onTicketRequestSaved() {
        this.loadData();
        this.emit("change");
    }

   
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TicketContingentView);